<template>
  <div class="bg-loginimg">
    <div class="container" id="login-form">
      <form class="row" @submit.prevent="handleRegister" autocomplete="off">
        <div class="col-md-4 col-sm-offset-4">
          <div class="brandrgitr">
            <div
              class="panel panel-default login-ragis-formstylechen-aftersell"
            >
              <div class="panel-body nopadding">
                <div class="panel-heading">
                  <h2>Register</h2>
                </div>
                <div class="form-horizontal" id="validate-form">
                  <div class="col-xs-12">
                     <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <v-select
                        v-model="OrganizationType"
                        :reduce="(seg) => seg.value"
                        :label="'text'"
                        :options="optionsOrganizationType"
                        :clearable="false"
                        :searchable="false"
                        @input="changedOrganizationType"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <v-select
                        v-model="partnerType"
                        :reduce="(seg) => seg.value"
                        :label="'text'"
                        :options="optionsPartnerRolesTypes"
                        :clearable="false"
                        :searchable="false"
                        @input="registerComponentEnable"
                        :disabled="partnerTypeIsEnable"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-xs-12" v-if="partnerType == 'Distributors'">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.DistributorCode"
                          name="DistributorCode"
                          placeholder="Distributor Code"
                          v-validate="'required'"
                          :readonly="readonly_component"
                           data-vv-as="Distributor Code"
                        />
                        <span v-if="errors.has('DistributorCode')">
                          {{ errors.first('DistributorCode') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.ShopName"
                          placeholder="Shop Name"
                          name="ShopName"
                          :readonly="readonly_component"
                          v-validate="'required'"
                           data-vv-as="Shop Name"
                        />
                        <span v-if="errors.has('ShopName')">
                          {{ errors.first('ShopName') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.FirstName"
                          placeholder="First Name"
                          name="FirstName"
                          :readonly="readonly_component"
                          v-validate="'required'"
                           data-vv-as="First Name"
                        />
                        <span v-if="errors.has('FirstName')">
                          {{ errors.first('FirstName') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.LastName"
                          placeholder="Last Name"
                          name="LastName"
                          :readonly="readonly_component"
                          v-validate="'required'"
                           data-vv-as="Last Name"
                        />
                        <span v-if="errors.has('LastName')">
                          {{ errors.first('LastName') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="email"
                          class="form-control"
                          v-model="register.EmailID"
                          name="EmailID"
                          :readonly="readonly_component"
                          placeholder="Email"
                          v-validate="'email'"
                           data-vv-as="Email Address"
                        />
                        <span v-if="errors.has('EmailID')">
                          {{ errors.first('EmailID') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.ContactNo"
                          :readonly="readonly_component"
                          placeholder="Mobile Number *"
                          name="ContactNo"
                          v-validate="'required|digits:10'"
                          data-vv-as="Mobile Number"
                        />
                        <span v-if="errors.has('ContactNo')">
                          {{ errors.first('ContactNo') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="register.Password"
                          :readonly="readonly_component"
                          name="password"
                          placeholder="Password"
                          v-validate="'required|min:8|verify_password'"
                          ref="password"
                         
                        />
                        <span v-if="errors.has('password')">
                          {{ errors.first('password') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group mb-md">
                      <div class="input-group">
                        <input
                          class="form-control"
                          :readonly="readonly_component"
                          placeholder="Conform Password"
                          v-model="register.ConformPassword"
                          v-validate="'required|confirmed:password'" type="password"
                           name="password_confirmed"
                           data-vv-as="password confirmation"
                        />

                        <span v-if="errors.has('password_confirmed')">
                          {{ errors.first('password_confirmed') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
              <div class="col-xs-12 panel-footer">
                <div class="loginrgitr col-xs-6">
                  <h4>Already Registered</h4>
                  <router-link to="/login">Login</router-link>
                </div>
                <div class="col-xs-4">
                  <button
                    class="btn-raised btn-primary btn fixcolorAs"
                    :disabled="loading"
                  >
                    <span
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    <span>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="copyright">
        <p class="center">
          Copyright 2021, GladMinds Technologies Pvt Ltd. All Right Reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import UserService from '../services/user.service';
import Vue from 'vue';
import { Validator } from 'vee-validate';


Validator.extend('verify_password', {
        getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
        validate: value => {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(value);
        }
    });
function initialState() {
  return {
    DistributorCode: '',
    ShopName: '',
    FirstName: '',
    LastName: '',
    partnerType: '',
    ContactNo:'',
    EmailID:'',
    Password:'',
    ConformPassword:''
  };
}
export default {
  name: 'Register',
  data() {
    return {
      loading: true,
      register: initialState(),
      readonly_component: true,
      partnerTypeIsEnable: true,

      SuccessMessage: '',
      ErrorMessage:'',
      OrganizationType: null,
      optionsOrganizationType: [
        { value: null, text: 'Please Select Organisation Type' },
        { value: 'Channel Partner', text: 'Channel Partner' },
        { value: 'Service Partner', text: 'Service Partner' },
      ],
      partnerType: '',
      optionsPartnerRolesTypes: [],
      optionChannelPartner: [
        { value: '1', text: 'Select Channel Partner' },
        { value: 'Distributors', text: 'Distributors' },
        { value: 'Retailer', text: 'Retailer' },
      ],
      optionServicePartner: [
        { value: '1', text: 'Select Service Partner' },
        { value: 'Reborer', text: 'Reborer' },
        { value: 'Grinder', text: 'Grinder' },
        { value: 'ReborerPlusGrinder', text: 'Grinder Reborer' },
        { value: 'Mechanics', text: 'Mechanics' },
      ],
    };
  },
  components: { vSelect },
  methods: {
    changedOrganizationType(value) {
      if (value == 'Channel Partner') {
        this.partnerTypeIsEnable = false;
        this.optionsPartnerRolesTypes = [];
        this.optionsPartnerRolesTypes = this.optionChannelPartner;
        this.partnerType = '1';
        this.readonly_component = true;
      } else if (value == 'Service Partner') {
        this.partnerTypeIsEnable = false;
        this.optionsPartnerRolesTypes = [];
        this.optionsPartnerRolesTypes = this.optionServicePartner;
        this.partnerType = '1';
        this.readonly_component = true;
      } else {
        this.partnerTypeIsEnable = true;
        this.optionsPartnerRolesTypes = [];
        this.partnerType = null;
      }
    },
    registerComponentEnable(val) {
      if (val != '1') {
        this.readonly_component = false;
        this.loading = false;
        this.register.partnerType = val;
      } else {
        this.readonly_component = true;
        this.loading = true;
      }
    },
    handleRegister(e) {
      this.message = '';
      this.$validator.validateAll().then((res) => {
        if (!res) {
          return false
        } else {
          UserService.postMetod('kspgAPI/Partners/create', this.register).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                /*Get Partner type and set it again after reset */
                const pt =this.register.partnerType
                this.resetWindow();
                this.register.partnerType = pt;
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
      // Hide Messages
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (this.SuccessMessage = false), 5000);      
    },
     resetWindow: function () {
      Object.assign(this.$data.register, initialState());
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>